import React, { Component } from 'react';
import { Modal, Button, Col, Row, ControlLabel, FormControl, FormGroup } from 'react-bootstrap';
import Summary from './Summary';
import ReadonlySummary from './ReadonlySummary';
import Dropdown from 'react-dropdown';

const qtrDropdownOptions = [
  { label: 1, value: 1 },
  { label: 2, value: 2 },
  { label: 3, value: 3 },
  { label: 4, value: 4 }
]

const spxSymbol = '^GSPC'

class SummaryModal extends Component {
  constructor(props) {
    super(props);

    const spxQuarterly = this.props.benchmarkInfo.find(item => item.symbol === spxSymbol)

    this.state = {
      spxQuarterly: spxQuarterly.quarterly,
      currentQuarter: { 
        label: props.quarterInfo.currentQuarter, 
        value: props.quarterInfo.currentQuarter 
      }
    }
  }
  
  summarySection = () => {
    const { userPrivilege, quarterInfo, updateSummaryInput, 
      updateDbQuarterSummary, activePortfolioId } = this.props;
      
    if (userPrivilege === 'readonly') {
      return (
        <ReadonlySummary 
          quarterInfo={quarterInfo} /> 
      );
    } else {
      return (
        <Summary 
          quarterInfo={quarterInfo} 
          updateSummaryInput={updateSummaryInput} 
          updateDbQuarterSummary={updateDbQuarterSummary} 
          activePortfolioId={activePortfolioId} /> 
      );
    }
  }

  onQuarterChange = (value) => {
    this.setState({ currentQuarter: value });

    this.props.changeCurrentQuarter({
      portfolioId: this.props.activePortfolioId,
      newQuarter: value.value
    })
  }

  onSPXQuarterlyChange = (event) => {
    const value = event.target.value

    this.setState({ spxQuarterly: value })
    this.props.updateSPXQuarterly({
      activePortfolioId: this.props.activePortfolioId,
      symbol: spxSymbol,
      value
    })
  }

  changeQuarter = () => {
    const { userPrivilege } = this.props;

    if (userPrivilege !== 'readonly') {
      return (
        <Col md={8}>
          <FormGroup controlId="currentQuarter">
            <ControlLabel>Change current quarter:</ControlLabel>
            <Dropdown
              name="currentQuarter"
              value={this.state.currentQuarter}
              options={qtrDropdownOptions}
              onChange={this.onQuarterChange} />
            </FormGroup>
        </Col>
      );
    }
  }

  updateSPXQuarterly = () => {
    const { userPrivilege } = this.props;

    if (userPrivilege !== 'readonly') {
      return (
        <Col md={8}>
          <FormGroup controlId="spxQuarterly">
            <ControlLabel>SPX quarter:</ControlLabel>
            <FormControl
              name="spxQuarterly"
              type="number"
              value={this.state.spxQuarterly}
              onChange={(e) => this.onSPXQuarterlyChange(e)} />
          </FormGroup>
        </Col>
      );
    }
  }
  
  render() {
    const { showSummaryModal, closeModal } = this.props;

    return (
      <Modal show={showSummaryModal} onHide={() => closeModal('showSummaryModal')} className="toolbar-modal">
        <Modal.Header closeButton>
          <Modal.Title>Quarterly Performance</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md={12}>
              {this.summarySection()}
            </Col>

            {this.changeQuarter()}
            {this.updateSPXQuarterly()}
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button 
            bsStyle="default"  
            onClick={() => closeModal('showSummaryModal')}
          >Close</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default SummaryModal;